<span
  class="text-content"
  [ngClass]="['text-content', type]"
  [innerHTML]="text">
</span>
